export default __webpack_public_path__ + "src/images/packages/palms-on-the-rocks/d6a4824553e7ee9266cdf5e2c35ae054-2.jpg";